import { client } from './api-client';

// Parent Control
export const fetchStatusParentControl = () => client.get(`parental-control`);
export const setParentControl = (body) => client.post(`parental-control`, body);
export const unSetParentControl = (body) => client.post(`parental-control/stop`, body);
export const valideatePinParentControl = (body) => client.post(`parental-control/validate`, body);
